export default __webpack_public_path__ + "static/media/ipasOmen-web1.91db61c9.jpg";